import { useCallback, useState } from "react";

// Which screenshot the Ready designs gallery shows: the web admin opens on the desktop one, and the
// Provider can switch to the phone one. The choice is remembered in this browser only.
export type ThumbView = "desktop" | "mobile";

const STORAGE_KEY = "matcha.site.thumbView";

export function readThumbView(): ThumbView {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "mobile" ? "mobile" : "desktop";
  } catch {
    return "desktop";
  }
}

// A design published before desktop thumbnails has only the phone one.
export function thumbFor(
  design: { thumbUrl: string; thumbDesktopUrl: string | null },
  view: ThumbView
): { uri: string; view: ThumbView } {
  return view === "desktop" && design.thumbDesktopUrl
    ? { uri: design.thumbDesktopUrl, view: "desktop" }
    : { uri: design.thumbUrl, view: "mobile" };
}

export function useThumbView(): [ThumbView, (view: ThumbView) => void] {
  const [view, setView] = useState<ThumbView>(readThumbView);
  const choose = useCallback((next: ThumbView) => {
    setView(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // The choice then lasts until the page reloads.
    }
  }, []);
  return [view, choose];
}
